export const FLAG_MAINTENANCE = 'zezam_creator_app_maintenance'
export const FLAG_TRENDING_PRODUCTS_PAGE = 'zezam_creator_app_products_page'
export const FLAG_HIDE_DESIGN_OPTIONS = 'zezam_creator_app_hide_design_options'
export const FLAG_COMMISSION_SOURCE_SPLITTING =
  'zezam_commission_source_splitting'
export const FLAG_BRANDS_CAMPAIGN_DATA = 'zezam_brands_campaign_data'
export const FLAG_BRAND_MODAL = 'zezam_creator_app_brand_modal'
export const FLAG_DISABLE_DEPRECATED_FEATURES =
  'zezam_creator_app_disable_deprecated_features'
